import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { SessionSignalService } from '../services/end-session-signal.service';

@Injectable()
export class SessionInterceptor implements HttpInterceptor {

    constructor(private router: Router, private sessionSignal: SessionSignalService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            catchError((error) => {

                if (error.status === 401) {

                    if (error.error.error.endImpersonationSession) {
                        this.sessionSignal.emit401();
                    }


                }

                return throwError(() => error);
            })
        );
    }
}